export default __webpack_public_path__ + "static/media/stickynote.38861d82.svg";